export default "__VITE_ASSET__4b79d66b__"